// react router imports
import { Link, useLocation } from "react-router-dom";
// import useState to change navbar classes on scroll
import { useState } from "react";

function NavMenu() {
  // creating state to change the navbar classNames on scroll.
  // since the navbar is transparent changing the background and text color on scroll.
  const [navbar, setNavbar] = useState(false);

  // using useLocation to get the current path so we can hide specific links.
  let location = useLocation();

  // creating a function to return location path in lowercase.
  const isCurrentURL = (url) => {
    return location.pathname.toLowerCase() === url.toLowerCase();
  };

  // creating a function with a conditional to change the state of the navbar
  const changeBackground = () => {
    // console.log(window.scrollY);
    if (window.scrollY >= 80) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  // adding an event to listen when the page scrolls
  window.addEventListener("scroll", changeBackground);

  return (
    <nav
      className={
        // tenantry operator to change the navbar
        navbar
          ? "navbar navbar-expand-lg fixed-top navbar-light bg-light"
          : "navbar navbar-expand-lg fixed-top navbar-dark bg-transparent"
      }
    >
      <div className="container">
        <Link to="/" className="navbar-brand fw-bold">
          <span>XYZ</span>|CAFE
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNavAltMarkup"
          aria-controls="navbarNavAltMarkup"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon" />
        </button>
        <div className="collapse navbar-collapse" id="navbarNavAltMarkup">
          <div className="navbar-nav ms-auto mb-2 mb-lg-0">
            {/* checking the path to display Home link or null using the isCurrentUR() created above */}
            {!isCurrentURL("/") ? (
              <Link to="/" className="nav-link active">
                Home
              </Link>
            ) : null}
            {/* checking the path to display Profile link or null using the isCurrentUR() created above */}
            {!isCurrentURL("/profile") ? (
              <Link to="/profile" className="nav-link active">
                Profile
              </Link>
            ) : null}
            {/* checking the path to display Shop link or null using the isCurrentUR() created above */}
            {!isCurrentURL("/shop") ? (
              <Link to="/shop" className="nav-link active">
                Shop
              </Link>
            ) : null}
          </div>
        </div>
      </div>
    </nav>
  );
}

export default NavMenu;
